// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button } from '@mui/material';
import { useOAuthCallback } from './use-oauth-callback';
import { Heading } from '@shared/ui-kit/components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const OAuthCallback = () => {
  const { t } = useTranslation();
  const { error, isLoading } = useOAuthCallback();

  return (
    <div className="mt-48 flex flex-col items-center">
      <div className="flex flex-col items-center gap-8 rounded-lg bg-white px-20 py-10  text-center">
        <Heading
          variant="h3"
          title={
            isLoading
              ? t('aggregator.connecting-account', { ns: 'aggregator' })
              : error
              ? t('aggregator.connection-error', { ns: 'aggregator' })
              : t('aggregator.connection-success', { ns: 'aggregator' })
          }
        />
        {isLoading && (
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        )}
        <p className="max-w-md text-title-alt">
          {isLoading
            ? t('aggregator.connecting-message', { ns: 'aggregator' })
            : error
            ? error
            : t('aggregator.success-message', { ns: 'aggregator' })}
        </p>
        <Link to="/banks">
          <Button color="secondary" className="mt-4" disabled={isLoading}>
            {isLoading
              ? t('aggregator.connecting-button', { ns: 'aggregator' })
              : error
              ? t('aggregator.try-again-button', { ns: 'aggregator' })
              : t('aggregator.continue-button', { ns: 'aggregator' })}
          </Button>
        </Link>
      </div>
    </div>
  );
};
